module.exports = __webpack_public_path__ + "media/auth/set_password-679de915.svg";